import { render, staticRenderFns } from "./depositCouponModal.vue?vue&type=template&id=f2436650"
import script from "./depositCouponModal.vue?vue&type=script&lang=js"
export * from "./depositCouponModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports